// src/components/HeatmapLayer.js - ИСПРАВЛЕННАЯ ВЕРСИЯ
import maplibregl from 'maplibre-gl';
import mapiService from '../services/mapiService';

export class HeatmapLayer {
// src/components/HeatmapLayer.js - обновляем конструктор

constructor(map, options = {}) {
  if (!map || typeof map !== 'object') {
    throw new Error('HeatmapLayer: некорректный объект карты');
  }
  
  this.map = map;
  this.enabled = false;
  this.currentDataset = options.dataset || 'schools';
  
  // 🔥 ОБНОВЛЯЕМ ПОЛЕ ДЛЯ РЕАЛЬНЫХ ДАННЫХ ШКОЛ
  // Часто используемые поля в школьных данных:
  this.propertyField = options.propertyField || 'students'; // Попробуем сначала 'students'
  this.alternativeFields = ['enrollment', 'total_students', 'student_count', 'ENROLLMENT']; // Альтернативы
  
  // IDs для источников и слоев
  this.sourceId = 'heatmap-source';
  this.heatmapLayerId = 'heatmap-layer';
  this.circleLayerId = 'circle-layer';
  
  // Настройки
  this.minZoom = 3;
  this.maxZoom = 20;
  this.debugMode = false;
  
  // Кеш данных
  this.dataCache = new Map();
  this.currentData = null;
  
  // Event handlers
  this.clickHandler = null;
  this.mouseEnterHandler = null;
  this.mouseLeaveHandler = null;
  
  console.log('🌡️ HeatmapLayer initialized with real data support');
}

  async toggle(enabled) {
    this.enabled = enabled;
    console.log(`🌡️ HeatmapLayer: toggle(${enabled})`);
    
    if (enabled) {
      await this.show();
    } else {
      this.hide();
    }
  }

  async show() {
    console.log('🌡️ === CREATING HEATMAP VISUALIZATION ===');
    
    if (!this.map?.isStyleLoaded()) {
      console.error('❌ Map not ready!');
      return;
    }

    try {
      // Получаем данные
      const data = await this.loadData(this.currentDataset);
      if (!data || !data.features || data.features.length === 0) {
        console.error('❌ No data available for heatmap');
        return;
      }

      console.log(`✅ Loaded ${data.features.length} features for heatmap`);
      this.currentData = data;

      // Удаляем существующие слои
      this.hide();

      // Создаем источник данных
      this.map.addSource(this.sourceId, {
        type: 'geojson',
        data: data
      });

      // Создаем heatmap слой
      this.createHeatmapLayer();
      
      // Создаем circle слой
      this.createCircleLayer();

      // Настраиваем обработчики событий
      this.setupEventHandlers();

      console.log('🌡️ ✅ Heatmap visualization created successfully!');

    } catch (error) {
      console.error('❌ Error creating heatmap:', error);
    }
  }

// src/components/HeatmapLayer.js - обновляем метод loadData

async loadData(datasetId) {
  // Проверяем кеш
  if (this.dataCache.has(datasetId)) {
    console.log(`💾 Using cached data for ${datasetId}`);
    return this.dataCache.get(datasetId);
  }

  console.log(`📡 Loading data for ${datasetId}...`);
  
  try {
    let data;
    
    // 🔥 ИСПОЛЬЗУЕМ РЕАЛЬНЫЕ ДАННЫЕ MAPTILER
    if (datasetId === 'schools') {
      console.log('📚 Loading real school data from MapTiler...');
      
      const response = await fetch('https://docs.maptiler.com/sdk-js/assets/Public_School_Characteristics_2020-21_no_prop.geojson');
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      data = await response.json();
      console.log('✅ Real school data loaded:', data);
      
      // Проверяем структуру данных
      if (data.features && data.features.length > 0) {
        console.log('📊 Sample feature properties:', Object.keys(data.features[0].properties));
        console.log('📊 Total features:', data.features.length);
        
        // Анализируем доступные поля
        const sampleProps = data.features[0].properties;
        console.log('📊 Available data fields:', Object.keys(sampleProps));
        
        // Ищем поле с количеством студентов
        const studentFields = Object.keys(sampleProps).filter(key => 
          key.toLowerCase().includes('student') || 
          key.toLowerCase().includes('enrollment') ||
          key.toLowerCase().includes('total')
        );
        console.log('👥 Potential student count fields:', studentFields);
      }
    } else {
      // Fallback для других datasets
      data = await mapiService.getHeatmapData(datasetId);
    }
    
    // Кешируем данные
    this.dataCache.set(datasetId, data);
    
    return data;
    
  } catch (error) {
    console.error('❌ Error loading real data:', error);
    console.log('🎭 Falling back to mock data...');
    
    // Fallback к mock данным при ошибке
    return mapiService.generateMockHeatmapData(datasetId);
  }
}

  createHeatmapLayer() {
    console.log('🔥 Creating heatmap layer...');
    
    this.map.addLayer({
      id: this.heatmapLayerId,
      type: 'heatmap',
      source: this.sourceId,
      maxzoom: 14, // Heatmap исчезает на высоких зумах
      paint: {
        // Вес heatmap на основе количества студентов
        'heatmap-weight': [
          'interpolate',
          ['linear'],
          ['get', this.propertyField],
          0, 0,
          3000, 1 // Максимальное значение для нормализации
        ],

        // Интенсивность в зависимости от зума
        'heatmap-intensity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          0, 1,
          12, 3
        ],

        // 🌈 УЛУЧШЕННАЯ ЦВЕТОВАЯ СХЕМА (как в примере MapTiler)
        'heatmap-color': [
          'interpolate',
          ['linear'],
          ['heatmap-density'],
          0, 'rgba(68, 1, 84, 0)',      // Прозрачный фиолетовый
          0.01, 'rgba(68, 1, 84, 0.2)', // Слабый фиолетовый
          0.13, 'rgba(71, 44, 122, 1)', // Темно-фиолетовый
          0.25, 'rgba(59, 81, 139, 1)', // Синий
          0.38, 'rgba(44, 113, 142, 1)', // Синий-зеленый
          0.5, 'rgba(33, 144, 141, 1)',  // Бирюзовый
          0.63, 'rgba(39, 173, 129, 1)', // Зеленый
          0.75, 'rgba(92, 200, 99, 1)',  // Светло-зеленый
          0.88, 'rgba(170, 220, 50, 1)', // Желто-зеленый
          1, 'rgba(253, 231, 37, 1)'     // Ярко-желтый
        ],

        // Радиус heatmap в зависимости от зума
        'heatmap-radius': [
          'interpolate',
          ['linear'],
          ['zoom'],
          0, 2,
          9, 20
        ],

        // Прозрачность heatmap (исчезает при приближении)
        'heatmap-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7, 1,
          14, 0
        ]
      }
    });
  }

// src/components/HeatmapLayer.js - метод createCircleLayer()

createCircleLayer() {
  console.log('⭕ Creating circle layer...');
  
  this.map.addLayer({
    id: this.circleLayerId,
    type: 'circle',
    source: this.sourceId,
    minzoom: 8, // Круги появляются при приближении
    paint: {
      'circle-pitch-alignment': 'map',
      
      // 📏 ЗНАЧИТЕЛЬНО УМЕНЬШЕННЫЕ РАЗМЕРЫ КРУГОВ
      'circle-radius': [
        'interpolate',
        ['linear'],
        ['zoom'],
        9, [
          'interpolate', 
          ['linear'], 
          ['get', this.propertyField], 
          10, 0.1,    // 🔥 БЫЛО 0.5, СТАЛО 0.1 (очень маленькие)
          2000, 3     // 🔥 БЫЛО 10, СТАЛО 3 (маленькие даже для больших значений)
        ],
        16, [
          'interpolate', 
          ['linear'], 
          ['get', this.propertyField], 
          10, 1,      // 🔥 БЫЛО 5, СТАЛО 1 (маленькие на большом зуме)
          2000, 12    // 🔥 БЫЛО 50, СТАЛО 12 (умеренные для максимальных значений)
        ]
      ],

      // 🌈 НОВАЯ ЗЕЛЕНАЯ ЦВЕТОВАЯ СХЕМА (от светлого к темному)
      'circle-color': [
        'interpolate',
        ['linear'],
        ['get', this.propertyField],
        0,    '#F2FED1',  // 🔥 Светлый желто-зеленый (минимальные значения)
        200,  '#DBFB9A',  // 🔥 Светло-зеленый
        600,  '#ABF600',  // 🔥 Ярко-зеленый  
        1200, '#62A903',  // 🔥 Темно-зеленый (максимальные значения)
        2500, '#4A7A02'   // 🔥 Еще темнее для экстремальных значений
      ],

      // ⚪ ТОНКАЯ ОБВОДКА
      'circle-stroke-color': 'rgba(255, 255, 255, 0.8)', // Полупрозрачная белая обводка
      'circle-stroke-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8, 0,     // На малом зуме без обводки
        12, 0.5,  // 🔥 УМЕНЬШЕНА с 1 до 0.5
        16, 1     // 🔥 УМЕНЬШЕНА с 2 до 1
      ],

      // 👻 ПРОЗРАЧНОСТЬ КРУГОВ
      'circle-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8, 0,     // На зуме 8 = невидимы
        12, 0.85  // 🔥 Немного увеличена прозрачность для лучшей видимости маленьких кругов
      ]
    }
  });
}

  setupEventHandlers() {
    // Клик по кругу для показа popup
    this.clickHandler = (e) => {
      if (e.features.length > 0) {
        const feature = e.features[0];
        const props = feature.properties;
        
        // Создаем красивый popup
        const popupContent = this.createPopupContent(props);
        
        // 🔥 ИСПРАВЛЕНИЕ: Создаем popup через this.map вместо maplibregl
        const popup = new this.map.constructor.Popup()
          .setLngLat(e.lngLat)
          .setHTML(popupContent)
          .addTo(this.map);
      }
    };

    this.map.on('click', this.circleLayerId, this.clickHandler);

    // Изменение курсора при наведении
    this.mouseEnterHandler = () => {
      this.map.getCanvas().style.cursor = 'pointer';
    };

    this.mouseLeaveHandler = () => {
      this.map.getCanvas().style.cursor = '';
    };

    this.map.on('mouseenter', this.circleLayerId, this.mouseEnterHandler);
    this.map.on('mouseleave', this.circleLayerId, this.mouseLeaveHandler);
  }

  createPopupContent(properties) {
    const value = properties[this.propertyField] || 0;
    const name = properties.name || 'Unknown Location';
    const region = properties.region || 'Unknown Region';
    
    return `
      <div style="padding: 15px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; border-radius: 10px; font-family: system-ui; min-width: 250px;">
        <h3 style="margin: 0 0 10px 0; text-align: center; font-size: 16px;">🌡️ Heatmap Data Point</h3>
        
        <div style="margin-bottom: 10px;">
          <strong>Name:</strong> ${name}
        </div>
        <div style="margin-bottom: 10px;">
          <strong>Region:</strong> ${region}
        </div>
        <div style="margin-bottom: 10px;">
          <strong>${this.propertyField}:</strong> <span style="font-size: 18px; font-weight: bold;">${value.toLocaleString()}</span>
        </div>
        
        ${properties.teachers ? `<div style="margin-bottom: 10px;"><strong>Teachers:</strong> ${properties.teachers}</div>` : ''}
        ${properties.grade_span ? `<div style="margin-bottom: 10px;"><strong>Grade Span:</strong> ${properties.grade_span}</div>` : ''}
        
        <div style="font-size: 11px; opacity: 0.8; margin-top: 10px; text-align: center;">
          Click and drag to explore the map
        </div>
      </div>
    `;
  }

  // Изменение dataset
  async changeDataset(datasetId) {
    console.log(`🔄 Changing dataset to: ${datasetId}`);
    
    this.currentDataset = datasetId;
    
    if (this.enabled) {
      await this.show();
    }
  }

  // Изменение поля для визуализации
  changeProperty(propertyField) {
    console.log(`🔄 Changing property to: ${propertyField}`);
    
    this.propertyField = propertyField;
    
    if (this.enabled && this.currentData) {
      // Обновляем только paint свойства слоев
      this.updateLayerPaint();
    }
  }

  updateLayerPaint() {
    console.log('🎨 Updating layer paint properties...');
    
    // Обновляем heatmap вес
    if (this.map.getLayer(this.heatmapLayerId)) {
      this.map.setPaintProperty(this.heatmapLayerId, 'heatmap-weight', [
        'interpolate',
        ['linear'],
        ['get', this.propertyField],
        0, 0,
        3000, 1
      ]);
    }

    // Обновляем circle цвет и размер
    if (this.map.getLayer(this.circleLayerId)) {
      this.map.setPaintProperty(this.circleLayerId, 'circle-color', [
        'interpolate',
        ['linear'],
        ['get', this.propertyField],
        0, 'rgba(68, 1, 84, 100)',
        100, 'rgba(71, 44, 122, 100)',
        300, 'rgba(59, 81, 139, 100)',
        600, 'rgba(44, 113, 142, 100)',
        1000, 'rgba(33, 144, 141, 100)',
        1300, 'rgba(39, 173, 129, 100)',
        1600, 'rgba(92, 200, 99, 100)',
        2000, 'rgba(170, 220, 50, 100)',
        2500, 'rgba(253, 231, 37, 100)'
      ]);
    }
  }

  hide() {
    if (!this.map?.getStyle) return;

    try {
      // Удаляем слои
      if (this.map.getLayer?.(this.heatmapLayerId)) {
        this.map.removeLayer(this.heatmapLayerId);
      }
      
      if (this.map.getLayer?.(this.circleLayerId)) {
        this.map.removeLayer(this.circleLayerId);
      }

      // Удаляем источник
      if (this.map.getSource?.(this.sourceId)) {
        this.map.removeSource(this.sourceId);
      }

      this.removeEventHandlers();
    } catch (error) {
      console.warn('Hide error:', error);
      this.removeEventHandlers();
    }
  }

  removeEventHandlers() {
    if (!this.map?.off) return;

    try {
      if (this.clickHandler) {
        this.map.off('click', this.circleLayerId, this.clickHandler);
        this.clickHandler = null;
      }
      
      if (this.mouseEnterHandler) {
        this.map.off('mouseenter', this.circleLayerId, this.mouseEnterHandler);
        this.mouseEnterHandler = null;
      }
      
      if (this.mouseLeaveHandler) {
        this.map.off('mouseleave', this.circleLayerId, this.mouseLeaveHandler);
        this.mouseLeaveHandler = null;
      }
    } catch (error) {
      console.warn('Handler removal error:', error);
    }
  }

  getStats() {
    return {
      enabled: this.enabled,
      dataset: this.currentDataset,
      propertyField: this.propertyField,
      featuresCount: this.currentData?.features?.length || 0,
      debugMode: this.debugMode
    };
  }

  destroy() {
    this.hide();
    this.dataCache.clear();
    this.currentData = null;
    this.map = null;
  }
}